import script from "./MonitoramentoCobrancasJobs.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitoramentoCobrancasJobs.vue?vue&type=script&setup=true&lang=js"

import "./MonitoramentoCobrancasJobs.vue?vue&type=style&index=0&id=f1145a3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1145a3a"]])

export default __exports__